import Entity from '../entity'

export default class Fee extends Entity<number>{
    dealer_id: number;
    state_id: number;
    year: number;
    month: number;
    published: boolean;
}


